module.exports = __webpack_public_path__ + "static/media/skill14.d669b3d2.jpeg";